import React from "react";

import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

const NotFoundView = ({ message, className }) => {
    return (
        <>
            <div
                className={`no-result-wrapper flex items-center justify-center ${className}`}
            >
                <div className="no-result-item text-center p-0 sm:w-3/4">
                    <div className="no-result-img">
                        <img
                            src={
                                require("../../assets/images/no-result.png")
                                    .default
                            }
                            alt="NoResultImage"
                        />
                    </div>
                    <div>
                        <h3 className="text-3xl font-bold text-primary-color-orange mb-2">
                            404
                        </h3>
                    </div>
                    <p className="no-result-message text-xl">
                        {message || (
                            <Trans i18nKey="pageNotFound404">
                                We are sorry, but the page you requested was not
                                found.
                            </Trans>
                        )}
                    </p>
                    <Link to="/dashboard">
                        <button className="default-orange-outline-btn ml-2">
                            GO TO DASHBOARD
                        </button>
                    </Link>
                </div>
            </div>
        </>
    );
};

export default NotFoundView;
